import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import { IFormSection } from "../../types/common";
import { API_CREDIT_HOLDING_TYPES } from "../../utils/apis";
import {
  createColumn,
  createViewAction,
  formatDateTime,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_CREDIT_HOLDING_TYPES } from "../../utils/urls";

export const useCreditHoldingTypes = () => {
  const tableColumns = () => [
    createColumn("created_by", true, "Created By"),
    createColumn("type_code", true, "Type Code"),
    createColumn("credit_holding_type", true, "Credit Holding Type"),
    createColumn("description", true, "Description"),
    createColumn("is_active", true, "Is Active"),
    createColumn("created_at", true, "Created At"),
    createColumn("actions", false, "Actions"),
  ];

  const tableData = (data: any) => {
    return data?.map((item: any) => {
      return {
        ...item,
        created_by:
          item?.created_by?.first_name + " " + item?.created_by?.last_name,
        is_active: <BooleanTags status={item?.is_active} />,
        created_at: formatDateTime(item?.created_at),

        actions: (
          <FormActions
            actions={[createViewAction(URL_CREDIT_HOLDING_TYPES, item?.id)]}
          />
        ),
      };
    });
  };

  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: {
              message: "No data available",
            },
          },
        ],
      };
    }
    return {
      sections: [
        // {
        //         "id": "ca9d0e6b-2b7b-42cc-b570-709c7b8db207",
        //         "created_by": {
        //             "id": "33d35251-4c5e-4558-984e-ef1a9c459381",
        //             "first_name": "System",
        //             "last_name": "Admin",
        //             "username": "yoyapayy@gmail.com"
        //         },
        //         "created_at": "2026-01-27T14:34:17.760994+03:00",
        //         "updated_at": "2026-01-27T14:34:17.761039+03:00",
        //         "declaration": false,
        //         "deleted": false,
        //         "credit_holding_type": "Post Paid Invoice",
        //         "type_code": "TYP00347",
        //         "description": "Repayment of Invoice For used service",
        //         "is_active": true,
        //         "updated_by": null
        //     }
        {
          title: "Credit Holding Type Details",
          fields: {
            credit_holding_type: item?.credit_holding_type,
            type_code: item?.type_code,
            description: item?.description,
            is_active: <BooleanTags status={item?.is_active} />,
            created_at: formatDateTime(item?.created_at),
            updated_at: formatDateTime(item?.updated_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(URL_CREDIT_HOLDING_TYPES);

  return {
    tableColumns,
    tableData,
    viewData,
    formRoute,
  };
};

export const useCreditHoldingTypesForm = () => {
  const sections: IFormSection[] = [
    {
      title: "Credit Holding Type",
      fields: [
        {
          field_name: "credit_holding_type",
          label: "Credit Holding Type",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "type_code",
          label: "Type Code",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "description",
          label: "Description",
          type: "textarea",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_CREDIT_HOLDING_TYPES);

  return {
    sections,
    redirect,
  };
};

export const submitCreditHoldingTypes = (payload: any, id: string) => {
  if (id) {
    return {
      id,
      api: API_CREDIT_HOLDING_TYPES,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_CREDIT_HOLDING_TYPES,
    params: {
      ...payload,
    },
  };
};
